import useTopicWork from "common/topic/provider/TopicWork/TopicWork";
import { useTopicWorkSetPath } from "common/topic/provider/TopicWork/UseTopicWorkSetPath";
import { TopicRelateAnswerProvider } from "./provider/TopicRelateAnswer";
import RelatePlayCharacters from "./RelatePlayCharacters";

const RelatePlay = () => {
  const { topicWork } = useTopicWork();
  useTopicWorkSetPath();

  return (
    <>
      {topicWork?.id && (
        <TopicRelateAnswerProvider topicId={topicWork.id}>
          <RelatePlayCharacters />
        </TopicRelateAnswerProvider>
      )}
    </>
  );
};

export default RelatePlay;
